<div class="settings-box-shadow">
  <h3 class="no-left-margin">Extension <span class="font-weight-bold">Details</span></h3>
  <div class="button-row">
    <vng-card variant="ghost" padding="none">
      <p *ngIf="!isInstalled">
        Download Extension to start using FlyMSG.
        {{
          isChromeBrowser
            ? "If already installed, enable extension."
            : "To fully use FlyMSG, you will need to use Chrome Browser."
        }}
      </p>
      <div style="display:flex; flex-direction:column; gap:5px" *ngIf="isInstalled">
        <div>
          <strong>Your Version : </strong>
          <span>{{ version }}</span>
        </div>
        <div>
          <strong>License: </strong>
          <span> {{ planId }}</span>
        </div>
      </div>
    </vng-card>
  </div>
</div>
